import styled from 'styled-components';
import { color, layout } from 'styled-system';

const StyledSidebar = styled.div`
	min-height: 100%;
	align-items: stretch;
	width: 100%;
	max-width: ${({ hasCampaignRegistration }) => hasCampaignRegistration && `var(--campaignRegWidth)`};
	margin: ${({ hasCampaignRegistration }) => (hasCampaignRegistration ? 'auto' : '0')};
	display: flex;
	flex-flow: column nowrap;
	background-color: var(--sidebar-bg, rgba(var(--base-11), 1));
	${({ $isNew }) => ($isNew ? `overflow: hidden; max-height: 100%;` : '')};

	${color}
	${layout}
`;

const Sidebar = ({ children, className, hasCampaignRegistration, ...rest }) => {
	return (
		<StyledSidebar className={className} hasCampaignRegistration={hasCampaignRegistration} {...rest}>
			{children}
		</StyledSidebar>
	);
};

export default Sidebar;
